import { render } from "./BaseInputHint.vue?vue&type=template&id=007b0ae0"
import script from "./BaseInputHint.vue?vue&type=script&lang=js"
export * from "./BaseInputHint.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__